import { render, staticRenderFns } from "./UpdateDialog.vue?vue&type=template&id=5457f4c0"
import script from "./UpdateDialog.vue?vue&type=script&lang=ts"
export * from "./UpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports